import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';

import { getCoutnryCity, exportSubscriber } from '../../../redux/actions/emailManagerActions';
import { CSVLink } from "react-csv";

let cityID = [];
let csvData = [];
let isLoading = "false";
class ExportSubscriber extends Component {
  constructor(props){
    super(props);
    this.state = {
      startDateValue : true,
      startDateRange :  '',
      startDateRangeStatus : false,
      cityList: '',
      cityID: '',
      cityError: false,
      dateError: false,
      path: ['Home', 'Export Subscribers'], 
      links: ["home",'/export-subscriber'],
      allCheck: false,
      fileName: 'Subscribers_' + moment(),
      allCity: 1,
      csvData: '',
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount(){
    isLoading = "true";
    this.props.getCoutnryCity();
  }

  componentWillReceiveProps(nextProps){
    
    if(this.props.cityList !== nextProps.cityList){
        if(nextProps.cityList){
          isLoading = "false";
          this.setState({cityList: nextProps.cityList.data});
        }
    } 

    if(this.props.exportStatus !== nextProps.exportStatus){
      if(nextProps.exportStatus){
          isLoading = "false";
          this.handleExport(nextProps.exportStatus.data);
      }
    }

  }

  handleExport = data => {
    csvData = [
      [
        "#",
        "Email",
        "First Name",
        "Last Name",
        "Zip Code",
        "City",
        "State",
        "Country",
        "Status",
        "Language",
      ]
    ];

    if (data) {
      data.map((list, index) => {
        csvData.push([
          ++index,
          list.Email,
          list.FirstName,
          list.LastName,
          list.ZipCode,
          list.City,
          list.State,
          list.Country,
          list.Status,
          list.Language,
        ]);
      });
    }

    this.setState({ csvData: csvData });
  };

  onChangeStartDateRange = date => {
    this.setState({ startDateRange: date});
    this.setState({dateError: false});
  }

  handleCityData = (e) => {
    cityID = (this.state.cityID) ? this.state.cityID : [];
    let index;

    if (e.target.checked) {
      cityID.push(e.target.value);
    } else {
      index = cityID.indexOf(e.target.value)
      cityID.splice(index, 1)
    }
    this.setState({cityError: false});
    this.setState({cityID : cityID});
  }

  handleAllCheck = (e) => {
    if (e.target.checked) {
      this.setState({allCheck : true, allCity: 0 });
    } else {
      this.setState({allCheck : false, allCity: 1 });
    }
  }

  validate = (e) => {
    let isError = false;
    if(this.state.cityID.length == 0 && this.state.allCity == 1){
      isError = true;
      this.setState({cityError: true});
    }else{
      this.setState({cityError: false});
    }

    if(this.state.startDateRange == '' && this.state.startDateValue == ''){
      isError = true;
      this.setState({dateError: true});
    }else{
      this.setState({dateError: false});
    }

    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    let dateRange;
    if(!isError){
      dateRange = (this.state.startDateRange) ? this.state.startDateRange : '';
      const constData = {
        fileName: this.state.fileName,
        allCity: this.state.allCity,
        cityIDs: this.state.cityID,
        typesubs:this.state.typesubs,
        dates: (this.state.startDateValue) ? 0 : 1,
        fromDate: (dateRange) ? moment(dateRange[0]).format() : '',
        toDate: (dateRange) ? moment(dateRange[1]).format() : '',
      }
      isLoading = "true";
      this.props.exportSubscriber(constData);
    }
  }
   
  handletypesubs = (e) => {
    this.setState({typesubs: e.target.value});
  }

  handSubscriptionDate = (e) => {
     if (e.target.checked) {
      this.setState({startDateRangeStatus : false, startDateValue: 'all', startDateRange: ''})
     } else {
      this.setState({startDateRangeStatus : true, startDateValue: ''})
     }

     this.setState({dateError: false});
  }

  render() {
    
  return (
    <div className="col-lg-12 add-sub-admin">
    {isLoading == "true" ? (
      <div className="loader">
        <p className="loading-message">
          <i>Loading...</i>
        </p>
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>
    ) : (
      ""
    )}
    <div className="row">
      <div className="col-xs-12">
         <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
      </div>
    </div>
    <form>
      <div className="panel">
          <header className="panel-heading">Export Subscribers</header>
          <div className="panel-body">
          <Row>
              <Col md={12} xs={12}>
                <FormGroup>
                  <Row>
                      <Col md={6} xs={6}>
                        <ControlLabel>File Name:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="File Name"
                          defaultValue={this.state.fileName}
                          name="fileName"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.campaignNameError}}
                        />
                      </Col>
                  </Row>
                  <br />
                  <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>Type of Subscribers:</ControlLabel> 
                      </Col>
                      <Col md={4} xs={6}> 
                        <Radio name="typesubs" value="1" checked={this.state.typesubs==='1' ? true : false} onClick={this.handletypesubs} > Subscriber </Radio>
                      </Col>
                      <Col md={4} xs={6}>
                        <Radio name="typesubs" value="0" checked={this.state.typesubs==='0' ? true : false} onClick={this.handletypesubs} > Unsubscriber </Radio>
                      </Col> 
                  </Row>
                  <Row>
                    <Col md={12} xs={12}>
                      <br/><ControlLabel>Subscribers in the following Cities: <span className="text-danger">{(this.state.cityError) ? '(Please select city.)' : ''}</span></ControlLabel>
                    </Col>
                  </Row>
                  <Row>
                      <Col md={12} xs={12}>
                        <Checkbox value="all" onClick={this.handleAllCheck}>Select All City</Checkbox>
                      </Col>
                  </Row>
                  {(this.state.cityList) &&
                    this.state.cityList.map((data, index) =>
                      <Row>
                      <Col md={12} xs={12}><b>{(data.cities.length != 0) ? data.country : ''}</b></Col>
                        <Col md={12} xs={12}>
                          <Row>
                          {data.cities.map((cityData, index) => 

                              <Col md={4} xs={12}>
                                {(cityID.indexOf(JSON.stringify(cityData.cityID)) > -1) ?
                                <Checkbox onClick={this.handleCityData} defaultChecked={true} value={cityData.cityID}>{cityData.title}</Checkbox>
                                :
                                <Checkbox onClick={this.handleCityData} checked={this.state.allCheck}  value={cityData.cityID}>{cityData.title}</Checkbox>
                                }
                              </Col>
                            )
                          }
                          </Row>
                        </Col>
                      </Row>
                    )
                  }
                </FormGroup>
              </Col>
              <Col md={12} xs={12}>
                <FormGroup>
                  <ControlLabel>Subscription Date: <span className="text-danger">{(this.state.dateError) ? '(Please select date option.)' : ''}</span></ControlLabel>
                  <Checkbox name="dates" defaultChecked={this.state.startDateValue} onClick={this.handSubscriptionDate}>
                    All Dates
                  </Checkbox>
                  {(this.state.startDateRangeStatus) &&
                  <DateRangePicker
                    onChange={this.onChangeStartDateRange}
                    value={this.state.startDateRange}
                  />
                  }
                </FormGroup>
              </Col>
          </Row>
          
          <Row><hr/></Row>
          <Row>
            <Col md={12} xs={12}>
              <Button bsStyle="success" className="pull-right" onClick={this.handleSubmit}>Export List</Button>
              {this.state.csvData ? (
                <CSVLink
                  data={this.state.csvData}
                  filename={this.state.fileName+".csv"}
                  className="btn btn-danger"
                >
                Download Subscriber List
                  </CSVLink>
                ) : null}
            </Col>
          </Row>
          </div>
      </div>
    </form>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.emailManagerReducer.error,
      cityList:  state.emailManagerReducer.cityList,
      exportStatus:  state.emailManagerReducer.exportStatus,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {getCoutnryCity, exportSubscriber})
)(ExportSubscriber);


// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/ExportSubscriber.js